import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Row, Column } from 'components/shared/Layout';
import { travelPassProductShape } from 'constants/propTypes';
import Subscription from './Subscription';
import { StyledExtrasContainer } from '../Extras.styles';
import { hasItem } from '../Extras.utils';

const ExtrasSubscriptions = ({ travelPassProducts }) => (
  <Row span={14} start={2} data-testid="row">
    <h1>
      <FormattedMessage id="subscriptions.title" />
    </h1>
    {hasItem(travelPassProducts) ? (
      <StyledExtrasContainer data-testid={`subscription`}>
        {travelPassProducts.map(
          (travelPassProduct) =>
            !travelPassProduct.cancelled && (
              <Subscription key={`subscription-${travelPassProduct.itemRef}`} travelPassProduct={travelPassProduct} />
            )
        )}
      </StyledExtrasContainer>
    ) : (
      <Column>
        <FormattedMessage id="subscriptions.noSubscriptions" />
      </Column>
    )}
  </Row>
);

ExtrasSubscriptions.propTypes = {
  travelPassProducts: PropTypes.arrayOf(travelPassProductShape.isRequired)
};

export default ExtrasSubscriptions;
